// removed by extract-text-webpack-plugin
module.exports = {"tr":"tr-1Bnv1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-row/table-row.less
 ** module id = 203
 ** module chunks = 0
 **/